export class EditTabsModel {
    Tabs: EditTabModel[] = [];
    Buttons: EditTabsButtonModel[] = null;
    PageTitle: string;
    ButtonBackTitle: string;
    ButtonSaveTitle: string;
    ButtonsRightAligned: any[] = [];
    constructor(pageTitle: string, buttonBackTitle?: string, buttonSaveTitle?: string) {
        this.PageTitle = pageTitle || '';
        this.ButtonBackTitle = buttonBackTitle;
        this.ButtonSaveTitle = buttonSaveTitle;
    }
}

export class EditTabsButtonModel {
    Title: string;
    OnClick: () => void;
    CssClass: string;
    constructor(Title: string, OnClick: () => void, CssClass: string) {
        this.Title = Title;
        this.OnClick = OnClick;
        this.CssClass = CssClass;
    }
}

export class EditTabModel {
    Name: string;
    Title: string;
    TemplateUrl: string; // todo: remove
    IsDisabled: boolean;
    constructor(name: string, displayName: string, templateUrl?: string, isDisabled?: boolean) {
        //todo templateUrl weill be removed
        this.Name = name || '';
        this.Title = displayName || '';
        this.TemplateUrl = templateUrl || '';
        this.IsDisabled = isDisabled || false;
    }
    SetDisabled(newValue: boolean) {
        this.IsDisabled = newValue;
    }
}
